import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { ROLE_LABELS } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { tx } from "@/i18n";

export const ChatMembersDialog = ({ channelId, open, onOpenChange, onSaved }) => {
  const [users, setUsers] = useState([]);
  const [base, setBase] = useState([]);
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open || !channelId) return;
    Promise.all([api.get("/users"), api.get("/chat/direct-members", { params: { channel_id: channelId } })])
      .then(([u, m]) => {
        setUsers(u.data.filter((x) => !["guest", "client"].includes(x.role) && x.active !== false && !(x.status === "pending")));
        setBase(m.data.base); setSel(m.data.members);
      }).catch((e) => toast.error(apiError(e)));
  }, [open, channelId]);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/chat/direct-members", { channel_id: channelId, members: sel });
      toast.success(tx("Deelnemers bijgewerkt"));
      onOpenChange(false); onSaved?.();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  const baseNames = users.filter((u) => base.includes(u.id)).map((u) => u.name).join(" en ");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-md rounded-2xl" data-testid="chat-members-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{tx("Deelnemers toevoegen")}</DialogTitle>
          <DialogDescription>{tx("Gesprek van")} {baseNames}. {tx("Gekozen medewerkers zien ook de eerdere berichten.")}</DialogDescription>
        </DialogHeader>
        <div className="max-h-72 overflow-y-auto space-y-1.5">
          {users.filter((u) => !base.includes(u.id)).map((u) => (
            <label key={u.id} className="flex items-center gap-2.5 p-2 rounded-md hover:bg-accent cursor-pointer text-sm" data-testid={`chat-member-${u.id}`}>
              <Checkbox checked={sel.includes(u.id)} onCheckedChange={(v) => setSel((p) => (v ? [...p, u.id] : p.filter((x) => x !== u.id)))} />
              <span className="truncate">{u.name} <span className="text-xs text-muted-foreground">· {ROLE_LABELS[u.role] || (u.role === "staff" ? "Staf" : u.role)}</span></span>
            </label>
          ))}
        </div>
        <DialogFooter>
          <Button onClick={save} disabled={busy} className="bg-primary hover:bg-primary/90 gap-2" data-testid="chat-members-save">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} {tx("Opslaan")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
